// extracted by mini-css-extract-plugin
export default {"stub":"ErrorReportCSS_stub__nDS5Y","placeHolderShimmer":"ErrorReportCSS_placeHolderShimmer__I8+eQ"};